// useEntitySearchEvent.js
// Hook to listen for global entity search events

import {useEffect} from 'react';

/**
 * Hook to listen for global 'openEntitySearch' events
 * This allows plugins to trigger the entity search dialog
 *
 * @param {Function} onOpenSearch - Callback to open search with (view, initialQuery)
 */
export function useEntitySearchEvent(onOpenSearch) {
    useEffect(() => {
        const handleOpenSearch = (event) => {
            const {view} = event.detail;
            if (!view) return;

            const {from, to} = view.state.selection;
            const initialQuery = from !== to
                ? view.state.doc.textBetween(from, to, ' ')
                : '';

            onOpenSearch(view, initialQuery);
        };

        window.addEventListener('openEntitySearch', handleOpenSearch);
        return () => window.removeEventListener('openEntitySearch', handleOpenSearch);
    }, [onOpenSearch]);
}

